import { useEffect, useState } from "react";

export default function Wheel() {
  const [isSpinning, setIsSpinning] = useState(false);
  const [hasSpun, setHasSpun] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [result, setResult] = useState(null);
  const [history, setHistory] = useState();

  const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;
  // Définition des segments de la roue avec récompenses
  const segments = [
    { label: "100F", color: "#3B82F6", reward: 100, id: 1 },
    { label: "100F", color: "#10B981", reward: 100, id: 2 },
    { label: "100F", color: "#EAB308", reward: 100, id: 3 },
    { label: "100F", color: "#EF4444", reward: 100, id: 4 },
    { label: "100F", color: "#8B5CF6", reward: 100, id: 5 },
    { label: "BONUS", color: "#EC4899", reward: 100, id: 6 },
  ];

  const segmentAngle = 360 / segments.length;

  const fetchHistory = async (signal) => {
    const token = localStorage.getItem("token");
    if (!token) return null;

    const res = await fetch(`${apiUrl}/api/tasks/wheel`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      signal,
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.message || "Erreur fetch history");
    }
    return res.json();
  };

  const callWheelAPI = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) throw new Error("Utilisateur non authentifié");

      const response = await fetch(`${apiUrl}/api/tasks/wheel`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ taskType: "wheel" }),
      });

      const data = await response.json();
      if (!response.ok) {
        console.error("Erreur API :", data);
        return data;
      }

      // Rafraîchir l'historique après POST
      try {
        const latest = await fetchHistory();
        if (latest) setHistory(latest);
      } catch (err) {
        console.warn("Impossible de rafraîchir l'historique :", err);
      }

      return data;
    } catch (error) {
      console.error("Erreur API :", error);
      throw error;
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const fetchWheelHistory = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.warn("No token found");
          return;
        }

        const response = await fetch(`${apiUrl}/api/tasks/wheel-history`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        });

        if (!response.ok) {
          const errorData = await response.json();
          console.error("Erreur fetch:", errorData);
          return;
        }

        const data = await response.json();
        setHistory(data.history);
      } catch (err) {
        if (err.name === "AbortError") return;
        console.error("Erreur fetch:", err);
      }
    };

    fetchWheelHistory();

    return () => controller.abort();
  }, [apiUrl]);

  // Vérifier si l'utilisateur peut tourner la roue (basé sur la date de la dernière tâche)
  const canSpin = (() => {
    if (!history || history.length === 0) return true;

    // console.log(history, history[history.length - 1].doneAt)
    const lastTaskDate = new Date(history[history.length - 1].doneAt); // supposé trié du plus récent au plus ancien
    const today = new Date();

    // console.log(lastTaskDate, " ET ", today)
    // console.log(today)

    const lastDay = `${lastTaskDate.getFullYear()}-${lastTaskDate.getMonth() + 1}-${lastTaskDate.getDate()}`;
    const todayDay = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

    // console.log("Mercredi", today.getDay())
    return lastDay !== todayDay;
  })();

  const spinWheel = async (e) => {
    if (isSpinning) return;

    setIsSpinning(true);
    setResult(null);

    const baseRotation = 360 * (5 + Math.random() * 3);
    const randomAngle = Math.random() * 360;
    const totalRotation = rotation + baseRotation + randomAngle;

    setRotation(totalRotation);

    setTimeout(() => {
      // const normalizedAngle = (360 - (totalRotation % 360)) % 360;
      // const segmentIndex = Math.floor(normalizedAngle / segmentAngle);
      // const winner = segments[segmentIndex];
      const winner = segments[2];

      setResult(winner);
      setIsSpinning(false);
      callWheelAPI();
      setHasSpun(true);
    }, 4000);
  };

  const createSegmentPath = (index) => {
    const startAngle = (index * segmentAngle - 90) * (Math.PI / 180);
    const endAngle = ((index + 1) * segmentAngle - 90) * (Math.PI / 180);
    const radius = 150;
    const centerX = 150;
    const centerY = 150;

    const x1 = centerX + radius * Math.cos(startAngle);
    const y1 = centerY + radius * Math.sin(startAngle);
    const x2 = centerX + radius * Math.cos(endAngle);
    const y2 = centerY + radius * Math.sin(endAngle);

    return `M ${centerX} ${centerY} L ${x1} ${y1} A ${radius} ${radius} 0 0 1 ${x2} ${y2} Z`;
  };

  //Bloquage de l'affichage

  if (true)
    return (
      <>
        <div className="bg-purple-50 border-l-4 border-red-500 rounded-lg p-4">
          <h4 className="font-bold text-red-800 mb-2">ℹ️ Infomation</h4>
          <ul className="text-sm text-red-700 space-y-1">
            <li>Roue indisponible pour le moment</li>
            <li>Nous travaillons pour résoudre le problème au plus vite</li>
          </ul>
        </div>
      </>
    )



  return (
    <div className="space-y-4 pb-20">
      {/* Card de la roue */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-2 text-center">
          🎡 Roue de la Fortune
        </h2>
        <p className="text-sm text-gray-600 mb-6 text-center">
          Tournez la roue et gagnez des bonus !
        </p>

        {/* Container de la roue */}
        <div className="relative flex flex-col items-center justify-center overflow-hidden px-4">
          {/* Indicateur fixe en haut */}
          <div className="absolute top-0 z-30 -translate-y-4">
            <div className="w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-t-[25px] border-t-red-600 drop-shadow-lg"></div>
          </div>

          {/* La roue en SVG */}
          <div className="relative max-w-full">
            <svg
              width="300"
              height="300"
              viewBox="0 0 300 300"
              className="transition-transform duration-[4000ms] ease-out drop-shadow-2xl max-w-full h-auto"
              style={{
                transform: `rotate(${rotation}deg)`,
                transitionTimingFunction: "cubic-bezier(0.17, 0.67, 0.05, 1)",
              }}
            >
              <circle
                cx="150"
                cy="150"
                r="148"
                fill="none"
                stroke="#FCD34D"
                strokeWidth="4"
              />
              {segments.map((segment, index) => (
                <g key={index}>
                  <path
                    d={createSegmentPath(index)}
                    fill={segment.color}
                    stroke="white"
                    strokeWidth="2"
                  />
                  <text
                    x="150"
                    y="150"
                    fill="white"
                    fontSize="18"
                    fontWeight="bold"
                    textAnchor="middle"
                    dominantBaseline="middle"
                    transform={`rotate(${index * segmentAngle + segmentAngle / 2
                      } 150 150) translate(0 -85)`}
                  >
                    {segment.label}
                  </text>
                </g>
              ))}
              <circle cx="150" cy="150" r="35" fill="url(#centerGradient)" />
              <circle
                cx="150"
                cy="150"
                r="35"
                fill="none"
                stroke="white"
                strokeWidth="4"
              />
              <defs>
                <linearGradient
                  id="centerGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#FBBF24" />
                  <stop offset="100%" stopColor="#F97316" />
                </linearGradient>
              </defs>
              <text x="150" y="160" fontSize="24" textAnchor="middle">
                {isSpinning ? "🎲" : "🎯"}
              </text>
            </svg>
          </div>

          {/* Bouton de rotation */}
          <button
            onClick={spinWheel}
            className={`mt-8 px-8 py-4 rounded-xl font-bold text-white text-lg shadow-lg transform transition-all duration-300 ${(new Date()).getDay() !== 2 || !canSpin || isSpinning
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 hover:scale-105 active:scale-95"
              }`}
            disabled={(new Date()).getDay() !== 2 || !canSpin || isSpinning || hasSpun}
          >
            {(new Date()).getDay() !== 2 ? " 🔒Tour de roue uniquement les Mardis" :
              !canSpin
                ? "🔒 Vous avez déjà tourné cette semaine"
                : isSpinning
                  ? <span className="flex items-center gap-2">
                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                        fill="none"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      />
                    </svg>
                    Rotation en cours...
                  </span>
                  : "🎰 TOURNER LA ROUE"
            }
          </button>
        </div>
      </div>

      {/* Résultat */}
      {result && (
        <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-lg shadow-md p-6 text-white animate-bounce">
          <div className="text-center">
            <h3 className="text-2xl md:text-3xl font-bold mb-2">
              🎉 Félicitations !
            </h3>
            <p className="text-lg mb-2">Vous avez gagné :</p>
            <p className="text-4xl md:text-5xl font-bold mb-4">
              {result.label === "BONUS" ? "🎁 " : ""}
              {result.label}
            </p>
            <p className="text-sm opacity-90">
              {result.reward} F CFA ont été ajoutés à votre solde !
            </p>
          </div>
        </div>
      )}

      {/* Règles du jeu */}
      <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4">
        <h4 className="font-bold text-blue-800 mb-2 flex items-center gap-2">
          ℹ️ Guide
        </h4>
        <ul className="text-sm text-blue-700 space-y-1">
          <li>• Cliquez sur "TOURNER LA ROUE" pour participer</li>
          <li>• Vous pouvez jouer 1/7 jours (1 fois par semaine) gratuitement</li>
          <li>• Les gains sont crédités instantanément</li>
        </ul>
      </div>

      {/* Historique des gains */}
      <div className="bg-white rounded-lg shadow-md p-4 md:p-6">
        <h3 className="text-lg font-bold text-gray-800 mb-4">
          📊 Historique des gains
        </h3>
        <div className="space-y-2">
          {history &&
            history.map((entry, index) => (
              <div
                key={index}
                className="flex justify-between items-center py-2 border-b border-gray-100"
              >
                <div>
                  <p className="text-sm font-medium text-gray-800">
                    {new Date(entry.doneAt).toLocaleDateString()}
                  </p>
                  <p className="text-xs text-gray-500">
                    {new Date(entry.doneAt).toLocaleTimeString()}
                  </p>
                </div>
                <span className="text-green-600 font-bold">{"100f"}</span>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
